
import { commonfunc } from '~/mixin/common'
export default {
  name: 'CtgrLayer',
  components: {

  },
  mixins: [commonfunc],
  props: {
    isActive: {
      type: Boolean, default: false
    }
  },
  data () {
    return {
      activeTab: 'tab1', // 검색 순위 팝업 내부 탭
      active: '1', // 탭 index(활성화)
      fullCateVisible: false, // 카테고리 목록 mouseover 여부
      onFullCate: false, // 카테고리 목록 active
      activeIndex: 0, // 서브카테고리 액티브
      categoryList: [],
      reqMidCtgrList: [], // 소카 조회용 중카리스트
      tempList: [],
      categoryTree: [],
      selectedBig: null,
      selectedMid: null,
      depth1Height: 0,
      activeCategory: false,
      activeSub: false
    }
  },
  watch: {
    selectedBig () {
      this.$nextTick(() => {
        if (this.$refs.depth1) {
          this.depth1Height = this.$refs.depth1.offsetHeight
        }
      })
    },
    isActive (newVal) {
      if (!newVal) {
        this.selectedBig = null
        this.selectedMid = null
      }
      this.$nextTick(() => {
        if (this.$refs.depth1) {
          this.depth1Height = this.$refs.depth1.offsetHeight
        }
      })
    }
  },
  async  mounted () {
    // Store에서 전체 카테고리 조회 (BreadCrumb와 공유)
    await this.$store.dispatch('ds/fetchAllCategoryList')
    await this.selCtgrList()
    // 만들어진 카테고리 리스트를 이용해서 트리를 구성
    this.makeCategoryTree()
  },
  beforeDestroy () {
    //   window.removeEventListener('click')
  },
  methods: {
    makeCategoryTree () {
      this.categoryList.forEach((lgctgrItem, lgctgrIdx) => {
        const dept0 = {
          id: lgctgrItem.id,
          menu: lgctgrItem.menu,
          link: lgctgrItem.link,
          icon: lgctgrItem.icon,
          activeIcon: lgctgrItem.activeIcon,
          exhCtgrNo: lgctgrItem.exhCtgrNo,
          iconAlt: lgctgrItem.iconAlt,
          isActive: lgctgrItem.isActive,
          subCateArr: null
        }
        const mctgrList = lgctgrItem.subMenu
        const subCateArr = []
        mctgrList.forEach((mctgrItem, mctgrIdx) => {
          if (mctgrIdx < 6) {
            subCateArr.push([mctgrItem])
          } else {
            let targetNum = 0
            let minCount = 0
            subCateArr.forEach((arrItem, arrIdx) => {
              let count = 0
              arrItem.forEach((arrItemInner) => {
                count = count + arrItemInner.subList.length
              })

              if (arrIdx === 0 || count < minCount) {
                minCount = count
                targetNum = arrIdx
              }
            })
            subCateArr[targetNum].push(mctgrItem)
          }
        })
        dept0.subCateArr = subCateArr
        this.categoryTree.push(dept0)
      })
    },
    test () {
      this.categoryList[0].isActive = true
      this.activeIndex = 0
    },

    closeCategory () {
      this.$emit('callCateClose')
      this.activeCategory = false
    },
    openCategory () {
      if (this.isActive) {
        this.activeSub = true
      }
    },

    async selCtgrList () {
      const payload = {
        exhCnrId: ''
      }
      await this.$AxiosBuilder
        .data(payload)
        .build()
        .post('/ds/ctgr')
        .then(async (res) => {
          const ctgrList = res.data.data
          ctgrList.forEach((item, i) => {
            const newItem = Object.assign({}, {
              id: i,
              menu: item.ctgrLayerNm,
              link: item.pcLinkUrl,
              icon: this.imgUrlMaker(item.pcomCtgrLayerAtchFileUrl),
              activeIcon: this.imgUrlMaker(item.pcomCtgrLayerAtchFileUrl),
              exhCtgrNo: item.exhCtgrNo,
              iconAlt: '',
              isActive: true,
              subMenu: []
            })
            // 대카먼저 넣어줌
            this.categoryList.push(newItem)

            const obj = {
              ctgrLayerNm: '신상',
              exhCtgrNo: 'newPd',
              uprExhCtgrNo: newItem.exhCtgrNo,
              pcLinkUrl: '/ds/exhCtgr/C208/' + newItem.exhCtgrNo + '?newPdYn=Y',
            }

            if (newItem.exhCtgrNo !== 'CTGR_00847') { // 상품권일때 신상 제거
              ctgrList[i].childCategories = [obj, ...ctgrList[i].childCategories]
            }

            const mdCtgrList = ctgrList[i].childCategories
            // console.table('mdCtgrList :::', mdCtgrList)
            // 중카까지 세팅
            mdCtgrList.forEach((item, index) => {
              const newMdItem = Object.assign({}, {
                subTitle: item.ctgrLayerNm,
                subMenuLink: item.pcLinkUrl,
                exhCtgrNo: item.exhCtgrNo,
                uprExhCtgrNo: item.uprExhCtgrNo,
                subList: [],
                badge: item.ctgrLayerNm === '신상' ? 'new' : ''
              })
              this.reqMidCtgrList.push(item.exhCtgrNo) // 소카 조회용 중카리스트 만들기
              this.categoryList[i].subMenu.push(newMdItem)
            })
            //   console.log('카테고리 리스트 서브메뉴 확인 ', this.categoryList[i].subMenu)
          })

          await this.selSmallCtgrList(this.reqMidCtgrList)
        }).catch((err) => {
          console.log(err)
        })
    },
    async selSmallCtgrList (arrA) {
      // 소카테 조회
      const smParamData = {
        exhCtgrNos: arrA
      }
      await this.$AxiosBuilder
        .data(smParamData)
        .build()
        .post('/ds/ctgr')
        .then((res) => {
          const smallCtgrList = res.data.data
          smallCtgrList.forEach((item, index) => {
            const newItem = Object.assign({}, {
              link: item.pcLinkUrl,
              name: item.ctgrLayerNm,
              exhCtgrNo: item.exhCtgrNo,
              uprExhCtgrNo: item.uprExhCtgrNo
            })
            this.tempList.push(newItem)
          })

          this.setSmallCate(this.categoryList, this.tempList)
        }).catch((err) => {
          console.log(err)
        })
    },
    setSmallCate (arrA, arrB) {
      arrA.forEach((lItem, index) => {
        lItem.subMenu.forEach((mItem, mIndex) => {
          //   console.table('Mitem :::::', mItem.exhCtgrNo, ㅣ'  index ::', index, '  mindex::', mIndex)
          for (let i = 0; i < arrB.length; i++) {
            if (mItem.exhCtgrNo === arrB[i].uprExhCtgrNo) {
              this.categoryList[index].subMenu[mIndex].subList.push(arrB[i])
            }
          }
          // 대카테고리가 CTGR_00022이고 건강식품(CTGR_01020) 중카일 때만 신상 항목 추가
          if (lItem.exhCtgrNo === 'CTGR_00022' && mItem.exhCtgrNo === 'CTGR_01020') {
            const newItem = {
              link: `/ds/exhCtgr/C208/${lItem.exhCtgrNo}/${mItem.exhCtgrNo}?newPdYn=Y`,
              name: '신상',
              exhCtgrNo: 'newPd',
              uprExhCtgrNo: mItem.exhCtgrNo,
              badge: 'new'
            }
            // 신상 항목을 0번 인덱스에 추가
            this.categoryList[index].subMenu[mIndex].subList.splice(0, 0, newItem)
          }
        })
      })
    },
    categoryMove (str) {
      this.$emit('callCateClose')
      this.$router.push(str)
      sessionStorage.setItem('filterCheck', [])
      sessionStorage.setItem('prodSortCheck', '')
    }
  }
}
